import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ShareableItems } from 'interfaces/shareables';
import { Tenants } from 'interfaces/tenants';
import { Users } from 'interfaces/users';
import type { ShareRecipientContactType } from 'utilities/share-recipient-validation';
import { fetchAll } from './shareablesActions';

export interface ShareRecipient {
    contact?: string;
    contactType?: ShareRecipientContactType;
}

interface IShareablesState {
    shareables: ShareableItems;
    tenants: Tenants | null;
    users: Users | null;
    loading: boolean;
    error: any | null;
    shareRecipients: ShareRecipient[];
    shareRecipientsError: string;
    memberIdListSelected: string[];
    excludedMembers: string[];
    includeAnnotations: boolean;
}

export const initialState: IShareablesState = {
    shareables: [],
    tenants: [],
    users: [],
    loading: false,
    error: null,
    shareRecipients: [{}],
    shareRecipientsError: '',
    memberIdListSelected: [],
    excludedMembers: [],
    includeAnnotations: false,
};

const shareablesSlice = createSlice({
    name: 'shareables',
    initialState,
    reducers: {
        reset: () => initialState,
        setterShareable: (state, action: PayloadAction<Partial<IShareablesState>>) => ({ ...state, ...action.payload }),
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAll.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchAll.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;

            if (!action.payload) return;

            state.shareables = action.payload.data.shareables;
            state.tenants = action.payload.data.tenants;
            state.users = action.payload.data.users;
        });
        builder.addCase(fetchAll.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.error = action.payload.data;
        });
    },
});

export const { reset, setterShareable } = shareablesSlice.actions;
export default shareablesSlice.reducer;
